import { MenuOpenOutlined } from "@mui/icons-material"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"

import AccordionGroup, { AccordionRow } from "@components/accordion_group"
import LeftDrawer from "@components/persist_drawer"
import SectionBar from "@components/section_bar"
import { PRIMARY } from "@constants/colors"
import { useUserPageContext } from "@contexts/main/users_page_context"

export default function ContactsPageLeftDrawer() {
  const { isLeftDrawerOpen, toggleIsLeftDrawerOpen, translate } =
    useUserPageContext()

  // const navigate = useNavigate()

  const [selectedValue, setSelectedValue] = useState("all")

  function handleRowClicked(value: string) {
    setSelectedValue(value)
  }

  const data: {
    title: string
    rowList: AccordionRow[]
    rightIconGroup?: React.ReactNode
    isDefaultOpen: boolean
  }[] = [
    {
      title: translate("role"),
      rowList: [
        {
          label: "All",
          value: "all"
        }
      ],
      isDefaultOpen: true
    }
  ]

  useEffect(() => {
    if (isLeftDrawerOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isLeftDrawerOpen])

  return (
    <LeftDrawer
      isOpen={!!isLeftDrawerOpen}
      header={<Header setClose={toggleIsLeftDrawerOpen} />}
      sx={{
        borderRight: 1,
        borderColor: "divider",
        width: "16rem",
        minWidth: "16rem",
        maxWidth: "16rem"
      }}
    >
      <AccordionGroup
        accordionList={data}
        selectedValue={selectedValue}
        onClick={handleRowClicked}
      />
    </LeftDrawer>
  )
}

function Header({ setClose }: { setClose?: () => void }) {
  const { translate } = useUserPageContext()

  return (
    <SectionBar
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        p: 1
      }}
    >
      <Typography p={1} variant="h6">
        {translate("users_tooltip")}
      </Typography>
      <IconButton
        disableRipple
        sx={{
          ":hover": {
            color: PRIMARY
          }
        }}
        onClick={setClose}
      >
        <MenuOpenOutlined />
      </IconButton>
    </SectionBar>
  )
}
